import { render, staticRenderFns } from "./ProductPriceChartModal.vue?vue&type=template&id=2da44315&scoped=true"
import script from "./ProductPriceChartModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceChartModal.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceChartModal.vue?vue&type=style&index=0&id=2da44315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da44315",
  null
  
)

export default component.exports